<template>
<div >
  <el-table
    :data="tableData"
    style="width: 100%"
    class="expand-table">
    <el-table-column
      prop="platform"
      :label="$t('preApprovalLogin.platform')">
    </el-table-column>
    <el-table-column
      prop="storeName"
      :label="$t('preApprovalLogin.storeName')"
      width="120px">
    </el-table-column>
    <el-table-column
      prop="area"
      :label="$t('preApprovalLogin.area')">
    </el-table-column>
    <el-table-column
      :label="$t('preApprovalLogin.file')"
      width="300">
      <template slot-scope="scope">
        <!-- {{ scope.row.fileList }}
        {{ scope.$index }} -->
         
        <el-upload
          :ref="`Uploader` + scope.$index"
          action
          :http-request="handleUpload"
          accept=".csv, .xlsx, .xls, .XLSX, .XLS, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :file-list="scope.row.fileList || []"
          :auto-upload="false"
          multiple
          :limit="10"
          :on-change="(file, fileList) => changeUpload(file, fileList, scope)"
          :on-remove="(file, fileList) => handleRemove(file, fileList, scope)"
          class="uploader"
        >
          <template>
            <!-- {{ scope.row.fileList }} -->
            <div v-if="!scope.row.fileList || scope.row.fileList.length === 0" class="xlsx-wrap">
              <span v-if="scope.row.platform === 'Amazon SC'" style="color: red">*</span>
              {{ $t('preApprovalLogin.uploadFile') }}
            </div>
            <i class="lls-icon-upload2"></i>
          </template>
        </el-upload>
        <!-- required 提示语 -->
        <!-- 亚马逊平台 file 文件必填 -->
        <div v-if="showErrTips && 
          scope.row.platform === 'Amazon SC' && 
          (!scope.row.fileList || scope.row.fileList.length === 0)" 
          class="err-tips"
        >
        {{ $t('preApprovalLogin.proceed') }}
        </div>
        <div v-if="platformOpenUrl[scope.row.platform][$i18n.locale === 'zh' ? 'urlCn' : 'urlEn']" class="question-icon" @click="openUrl(scope.row.platform)">?</div>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>
<script >
export default {
  name: 'preApprovalTable',
  components: {
    
  },
  props: {
    tableData: {
      type: [Array], 
      default: () => []
    }
  },
  data() {
    return {
      fileList: [],
      showErrTips: false,
      url: '',
      platformOpenUrl: {
        'Amazon SC': {
          fetchKey: 'authorization.store.url.amazonsc',
          urlCn: '',
          urlEn: ''
        },
        'JD VC': {
          fetchKey: 'authorization.store.url.jdvc',
          urlCn: '',
          urlEn: ''
        },
        'Others': {
          fetchKey: 'authorization.store.url.others',
          urlCn: '',
          urlEn: ''
        },
        
      }
    }
  },
  mounted () {
    console.log('this.$i18n.locale-->', this.$i18n.locale)
    // 同时获取中英文链接
    Object.values(this.platformOpenUrl).forEach(item => {
      const fetchKeys = [
        `authorization.store.url.cn.${item.fetchKey.split('.').pop()}`,
        `authorization.store.url.en.${item.fetchKey.split('.').pop()}`
      ]
      
      this.$API.system.getWebsiteUrl(fetchKeys).then(({ data }) => {
        item.urlCn = data.data[fetchKeys[0]]
        item.urlEn = data.data[fetchKeys[1]]
      })
    })
  },
  methods: {
    openUrl(platform) {
      const platformData = this.platformOpenUrl[platform]
      const url = this.$i18n.locale === 'zh' ? platformData.urlCn : platformData.urlEn
      window.open(url || '', '_blank')
    },
    async handleUpload ({ file, onProgress, onSuccess, onError }) {
    },
    // https://blog.csdn.net/qq_41077075/article/details/136813601
    // 选择文件时，往fileList里添加
    changeUpload(file, fileList, scope) {
      this.$set(scope.row, 'fileList', fileList);
    },
    handleRemove(file, fileList, scope) {
      this.$set(scope.row, 'fileList', fileList);
    },
    submitUpload() {
      const amazonList = this.tableData.filter(item => item.platform === 'Amazon SC')
      const flag = amazonList.some(item => item.fileList.length === 0)
      // 有非必填的
      if (flag) {
        this.showErrTips = true
        this.$emit('error')
        return
      }
      const arr = amazonList.map(item => this.upload(item))
      Promise.all(arr).then(res => {
        this.$emit('success')
      }).catch(err => {
        this.$emit('error')
      })
    },
    
    async upload (data) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        if (data.fileList && data.fileList.length > 0) {
          data.fileList.forEach((file) => {
            formData.append('files', file.raw)
          })
        } else {
          this.showErrTips = true
          reject()
        }
        formData.append('clientName', data.clientName)
        formData.append('docType', data.docType || 'settlement_offline')
        formData.append('programName', data.programName)
        formData.append('requestId', this.getNewUuid())
        formData.append('sellerId', data.storeName)
        formData.append('marketplace', data.area)
  
        this.$API.system.batchUpload(formData).then(({ data }) => {
          resolve()
        })
        .catch((err) => {
          reject()
        })
      })
    },
    getNewUuid () {
      return this.getUid().toString().replaceAll(/-/g, '')
    },
  }
}
</script>

<style lang="scss" scoped>
.expand-table ::v-deep {
  td, th {
    height: 40px;
    padding: 0
  }
  th, .el-table__empty-text {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  td {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;

  }
  td, th.is-leaf {
    border-bottom: 1px solid #D9E9FF;
  } 
  // .el-upload--text {
  //   float: right;
  // }
}
.uploader {
  border: 1px dashed #E8E8E4;
  border-radius: 2px;
  min-height: 30px;
  line-height: 30px;
  margin: 5px 0;
  position: relative;
  width: 230px;
  // display: flex;
  // flex-direction: row-reverse;
  // justify-content: space-around;
  &::v-deep {
    .el-upload {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 7px;
      font-size: 16px;
      color: #8C8C8C;
      flex: 1 1 0;
    }
    .xlsx-wrap {
      font-size: 12px;
      margin-left: 12px;
    }
    .el-upload-list {
      max-width: 80%;
    }
    .el-upload-list__item {
      margin-top: 0;
    }
    .lls-icon-upload2 {
      position: absolute;
      right: 7px;
      top: 7px;
    }
  }
}
.question-icon {
  width: 17.5px;
  height: 17.5px;
  border: 1px solid #8C8C8C;
  border-radius: 50%;
  color: #8C8C8C;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 250px;
  top: 12px;
}
.err-tips {
  color: red;
  font-size: 12px;
}
</style>
